/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Brief_Task_TermInputs */

const en_how_we_work_brief_task_term = /** @type {(inputs: How_We_Work_Brief_Task_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The task`)
};

const lv_how_we_work_brief_task_term = /** @type {(inputs: How_We_Work_Brief_Task_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzdevums`)
};

/**
* | output |
* | --- |
* | "The task" |
*
* @param {How_We_Work_Brief_Task_TermInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_brief_task_term = /** @type {((inputs?: How_We_Work_Brief_Task_TermInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Brief_Task_TermInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_brief_task_term(inputs)
	return en_how_we_work_brief_task_term(inputs)
});